import appDisplay from 'scoreboard/components/app-display'
import DisplayHeader from 'scoreboard/components/display-header'
import OverviewInfo from './overview/initiatives-overview-info'
import ViWizard from 'scoreboard/imports/vi/vi-wizard'
import permissions from 'scoreboard/components/permissions'
import _ from 'lodash'
import config from 'scoreboard/components/config'

var InitiativesDisplayHeader = DisplayHeader.extend({

	events: _.extend({}, DisplayHeader.prototype.events, {
		'click .import-initiative-status': 'importInitiativeStatus'
	}),

	render: function() {
		DisplayHeader.prototype.render.apply(this, arguments)

		// When the model is changed here, we not only want to update the
		// header text (done in DisplayHeader.prototype.initialize()) but we also
		// want to update the overview and edit tabs with the correct url based on the
		// new model id
		this.listenTo(this.model, 'change:label', (model) => {
			this.$('.overview-tab a').attr('href', 'initiatives/' + model.id)
			this.$('.edit-tab a').attr('href', 'initiatives/' + model.id + '/edit')
		})
		return this
	},

	//DisplayHeader will render the info icon because this function exists
	overviewInfo: function() {
		appDisplay.dialog(this.model.fetch({
			data: {
				relatedItems: true,
				assignees: true
			}
		}), function() {
			return new OverviewInfo({ model: this.model })
		}.bind(this))
	},

	// Opens the "Import Initiative Status" wizard
	// #29428  FIXME only needed until 2021 Commercial release
	//  this can be removed after that point in favor of ImportOptions
	importInitiativeStatus: function() {
		let viWizard = ViWizard.start({
			type: 'initiative-status',
			doneKey: 'admin.import.run'
		})
		viWizard.on('import-complete', () => {
			this.trigger('import-complete')
		})
	}
})

export default InitiativesDisplayHeader

InitiativesDisplayHeader.__filename__ = 'initiatives/initiatives-display-header.js'
